/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerCompany } from './';
import {
    FreelancerCompanyFromJSON,
    FreelancerCompanyFromJSONTyped,
    FreelancerCompanyToJSON,
} from './';

/**
 * 
 * @export
 * @interface Freelancer
 */
export interface Freelancer {
    /**
     * 
     * @type {string}
     * @memberof Freelancer
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof Freelancer
     */
    profileId?: string;
    /**
     * 
     * @type {FreelancerCompany}
     * @memberof Freelancer
     */
    company: FreelancerCompany;
    /**
     * 
     * @type {string}
     * @memberof Freelancer
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof Freelancer
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof Freelancer
     */
    headLine?: string;
    /**
     * 
     * @type {string}
     * @memberof Freelancer
     */
    photoUrl?: string;
}

/**
 * Check if a given object implements the Freelancer interface.
 */
export function instanceOfFreelancer(value: object): value is Freelancer {
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function FreelancerFromJSON(json: any): Freelancer {
    return FreelancerFromJSONTyped(json, false);
}

export function FreelancerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Freelancer {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'company': FreelancerCompanyFromJSON(json['company']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'headLine': json['headLine'] == null ? undefined : json['headLine'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
    };
}

export function FreelancerToJSON(value?: Freelancer | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
        'profileId': value['profileId'],
        'company': FreelancerCompanyToJSON(value['company']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'headLine': value['headLine'],
        'photoUrl': value['photoUrl'],
    };
}

